<app-patient-info [heading]="Item"></app-patient-info>

<div class="card grid col-12 ml-0 mb-3"
     style="display: flex; background-color: white; justify-content: space-between">
    <div class="grid col-7 pb-0">
        <h5 class="mt-3 pl-3"><strong>Lab Category: </strong></h5>

        <div class="col-10 md:col-10" style="margin-top: -6px">
            <p-dropdown *ngIf="distinctLabList"
                        [filter]="true"
                        dataKey="testName"
                        [options]="distinctLabList"
                        optionLabel="testDescription"
                        class="p-fluid"
                        [(ngModel)]="distinctLabTest"
                        (onChange)="Setlabitem()"
                        (onFocus)="onFocus()"
                        appendTo="body">

            </p-dropdown>
        </div>
    </div>

    <div class="col-4 alignRight" *ngIf="setPrintFlag">
        <button pButton type="button" icon="pi pi-download" label="Download" class="p-button-plain" (click)="downloadLabpdf()" title="Download pdf"></button>&nbsp;
        <button pButton type="button" icon="pi pi-print" label="Print" class="p-button-plain" (click)="printLabs()" title="Print Labs"></button>&nbsp;

    </div>
</div>

<div class="">
    <p-table 
             [responsive]="true"
             [columns]="cols"
             [value]="arrlabdetails"
             selectionMode="single"
             [scrollable]="true"
             [resetPageOnSort]="false"
             [lazy]="false"
             [rows]="rows"
             [paginator]="false"
             [autoLayout]="true">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{ Getheader(col.header) }}
                </th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body"
                     let-rowData
                     let-columns="columns"
                     let-i="rowIndex">
            <tr *ngIf="i != 0">
                <td *ngFor="let col of columns"
                    [ngClass]="selectCursor(rowData[col.field])"
                    (click)="setViews(rowData[col.field], col.header, rowData)">
                    <span class="{{ setSeverity(rowData[col.field]) }}">
                        {{
            Getfield(rowData[col.field])
                        }}
                    </span>
                </td>

                <td>
                    <button pButton
                            type="button"
                            icon="pi pi-chart-line"
                            class="p-button-info"
                            style="font-size: 0.7em"
                            (click)="getgraphDetails(rowData)"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <div class="w-12 bg-white">
                <div class="" style="text-align: center">
                    <img _ngcontent-ng-c683320295=""
                         class="profile-image"
                         style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                         src="assets/imagesNew/table_error.png" />
                </div>
                <hr style="margin-bottom: 0.5rem" />
                <div class=""
                     style="text-align: center; font-size: larger; color: #1d428f">
                    <i>No records found</i>
                </div>
            </div>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="displaychartstypepopup"
              [style]="{ width: '40%' }"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [maximizable]="true">
        <p-header>
            {{ popupheader }}
        </p-header>

        <div class="grid" *ngIf="graphdata?.labels?.length > 0">
            <div class="col-12 p-md12">
                <p-chart type="line"
                         [data]="graphdata"
                         [options]="chartOptions"></p-chart>
                <!--<p-chart type="line" [data]="graphdata" ></p-chart>-->
            </div>
        </div>

        <div class="w-12 bg-white" *ngIf="graphdata?.labels?.length == 0">
            <div class="" style="text-align: center">
                <img _ngcontent-ng-c683320295=""
                     class="profile-image"
                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                     src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class=""
                 style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>

        <p-footer style="display: flex; justify-content: center">
            <button pButton
                    type="button"
                    icon="ui-icon-close"
                    (click)="displaychartstypepopup = false"
                    label="Cancel"
                    class="ui-button-secondary"></button>
        </p-footer>
    </p-dialog>

    <p-dialog [(visible)]="popupDisplayDetails"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '50vw' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <p-header> Lab Details - {{ titleLabDetails }} </p-header>

        <div class="grid">
            <div class="col-12">
                <app-lab-details #labDetails></app-lab-details>
            </div>
        </div>
        <p-footer style="display: flex; justify-content: center"> </p-footer>
    </p-dialog>
</div>

<!-- Print functionality  for Labs List -->
<div class="panel table-responsive" id="PrintLabs_List" style="display: none">
    <div style="
      display: flex;
      background-color: #ffffff;
      margin-bottom: 1.5%;
      padding: 0.5%;
    ">
        <div style="
        display: flex;
        justify-content: left;
        align-items: center;
        width: 50%;
      ">
            <span>Labs:&nbsp;{{ testName?.testName }}</span>
        </div>
        <div style="
        display: flex;
        justify-content: right;
        align-items: center;
        width: 50%;
      ">
            <span><strong>{{ patientFullName }}</strong></span>
        </div>
    </div>

    <div style="
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0% 0% 0% 0%;
    ">
        <table style="width: 100%; border-collapse: collapse; border: 1px solid grey"
               id="Labs_print_table_tbody">
            <thead style="
          background-color: #142066;
          border: 0px solid #808080;
          color: snow;
        ">
                <tr>
                    <th *ngFor="let col of cols"
                        style="border: 1px solid #808080; text-align: left">
                        {{ Getheader(col.header) }}
                    </th>
                </tr>
            </thead>
            <tbody id="Labs_print_table_tbody">
                <tr *ngFor="let item of arrlabdetails | slice: 1"
                    style="border: 1px solid #808080">
                    <td *ngFor="let col of cols; let i = index"
                        style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            ">
                        {{ Getfield(item[col.field]) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="arrlabdetails?.length == 0"
         class="alert alert-warning"
         role="alert"
         style="text-align: center">
        <span class="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"></span>
        <span class="sr-only">Error:</span>
        <i>No records found</i>
    </div>
</div>




<!-- print functionality with multiple columms in a list-->


<div class="panel table-responsive" id="PrintLabs_List" style="display: none">








</div>
<p-dialog [(visible)]="printLayoutDesign"
          [draggable]="true"
          [modal]="true"
          positionType="absolute"
          [maximizable]="true"
          [style]="{width:'25vw'}">

    <p-header>Print Layout</p-header>

    <div class="grid">
        <div class="col-12 p-md-12">
            <div class="flex flex-wrap gap-5 justify-content-center">
                <!-- Layout 2 -->
                <div class="responsive-box" title="Fields are displayed as rows and records as columns for clarity">
                    <img src="../../../../assets/imagesNew/transpose.svg" alt="Layout 2" />
                    <p-radioButton name="printlayout" [(ngModel)]="printlayout" value="layout2" inputId="rblayout2" checked>
                    </p-radioButton>
                    <label for="rblayout2">&nbsp;Transpose</label>
                </div>
                <!-- Layout 1 -->


                <div class="responsive-box" title="Fields are displayed as rows and records as columns for clarity">
                    <img src="../../../../assets/imagesNew/ColumnBreakLayout.svg" alt="Layout 1" />
                    <p-radioButton name="printlayout" [(ngModel)]="printlayout" value="layout1" inputId="rblayout1">
                    </p-radioButton>
                    <label for="rblayout1">&nbsp;Column Break</label>
                </div>
                <!-- Layout 3 -->

                <div class="responsive-box" title="Fields are displayed as rows and records as columns for clarity">
                    <img src="../../../../assets/imagesNew/vertical.svg" alt="Layout 3" />
                    <p-radioButton name="printlayout" [(ngModel)]="printlayout" value="layout3" inputId="rblayout3">
                    </p-radioButton>
                    <label for="rblayout3">&nbsp;Vertical </label>
                </div>

                <!-- Add more layouts similarly if needed -->

            </div>
        </div>
    </div>

    
            <hr>
            <p-footer style="display:flex;justify-content:center;">
                <button pButton type="button" icon="pi pi-print" label="Print" class="p-button-success" (click)="printLabsLayout()" [disabled]="!printlayout"></button>
                <button pButton type="button" icon="pi pi-download" label="Download" class="p-button-primary" (click)="downloadLabsLayout()" [disabled]="!printlayout"></button>
                <button pButton type="button" icon="pi pi-times" label="Cancel" class="p-button-text" (click)="closeDialog()"></button>
            </p-footer>
</p-dialog>


<div #printSection style="display: none;"></div>
